export var HousingType;
(function (HousingType) {
    HousingType[HousingType["FLAT"] = 0] = "FLAT";
    HousingType[HousingType["TUSSENWONING"] = 1] = "TUSSENWONING";
    HousingType[HousingType["HOEKWONING"] = 2] = "HOEKWONING";
    HousingType[HousingType["TWEE_ONDER_EEN_KAP"] = 3] = "TWEE_ONDER_EEN_KAP";
    HousingType[HousingType["VRIJSTAAND"] = 4] = "VRIJSTAAND";
})(HousingType || (HousingType = {}));
